import React, { cloneElement } from 'react'
import { clsx } from 'clsx'

/**
 * Individual folder tab component.
 * 
 * Displays a single folder tab with:
 * - Folder icon and name
 * - Note count badge (temporarily disabled)
 * - Active state styling
 * - Special styling for default folders
 * - Drag & drop support (future enhancement)
 */

const FolderTab = ({
  isActive = false,
  onClick,
  icon,
  name,
  count = 0,
  color,
  isDefault = false,
  isAllNotesTab = false,
  folderType
}) => {

  const handleClick = () => {
    console.log('🔍 FolderTab: Click handler called for:', name)
    onClick?.()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick?.()
    }
  }

  // Render the icon with transition effects
  const renderIcon = () => {
    if (!icon) return null
    
    return cloneElement(icon, {
      className: clsx(icon.props.className, 'transition-colors duration-200')
    })
  }

  return (
    <button
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={clsx(
        // Base styles
        'flex items-center gap-2 px-3 py-2 rounded-t-lg text-sm font-medium transition-all duration-200',
        'min-w-fit whitespace-nowrap flex-shrink-0',
        'border-b-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
        
        // Active state
        isActive ? [
          'bg-white dark:bg-gray-900 text-blue-600 dark:text-blue-400',
          'border-blue-500 dark:border-blue-400',
          'shadow-sm'
        ] : [
          'bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300',
          'border-transparent hover:border-gray-300 dark:hover:border-gray-600',
          'hover:bg-white dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100'
        ],
        
        // Default folder styling
        isDefault && !isAllNotesTab && [
          'ring-1 ring-gray-200 dark:ring-gray-600',
          isActive ? 'ring-blue-200 dark:ring-blue-600' : 'hover:ring-gray-300 dark:hover:ring-gray-500'
        ],

        // All Notes tab special styling
        isAllNotesTab && [
          'font-semibold',
          isActive ? 'bg-blue-50 dark:bg-blue-900/20' : 'hover:bg-blue-50 dark:hover:bg-blue-900/10'
        ]
      )}
      style={{
        // Custom color accent for custom folders
        ...(color && !isDefault && !isAllNotesTab && isActive && {
          borderBottomColor: color,
        })
      }}
      aria-label={`${name} folder`}
      aria-selected={isActive}
      role="tab"
    >
      {/* Folder Icon */}
      <span className="flex items-center justify-center">
        {renderIcon()}
      </span>

      {/* Folder Name */}
      <span className="font-medium">
        {name}
      </span>

      {/* Note Count Badge */}
      {/* {count > 0 && (
        <span
          className={clsx(
            'inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 text-xs font-medium rounded-full',
            isActive ? [
              'bg-blue-100 dark:bg-blue-800 text-blue-800 dark:text-blue-200'
            ] : [
              'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300'
            ]
          )}
        >
          {count}
        </span>
      )} */}

      {/* Default folder indicator */}
      {isDefault && !isAllNotesTab && (
        <span className="text-xs text-gray-400 dark:text-gray-500 ml-1">
          •
        </span>
      )}
    </button>
  )
}

export default FolderTab 